// src/pages/expense/_shared/GenericDetailTablePanel.jsx
// ✅ 전 사업 확산 [5] — 카페 4개점처럼 템플릿마다 세부내역 표의 열 구성이 전부
// 제각각(포스임대료 5열/사회보험료 9열/명절격려품 6열 등)이라, 사업별로 전용 패널을
// 새로 만드는 대신 "템플릿의 columns 배열만 받아 그 열 그대로 여러 행을 입력받는"
// 범용 패널 하나로 해결한다. ExpenseItemPanel/SalaryPanel처럼 공급가/부가세를
// 자동 합산하지 않는다 — 열 의미가 템플릿마다 달라(어떤 열이 "총계"인지 고정할 수
// 없음) 합계는 기존처럼 폼의 공급가액/부가세 입력에 사용자가 직접 넣는다. 이 패널은
// 순수하게 PDF 미리보기의 세부내역 표를 채우는 용도.
import React, { useState } from "react";
import styles from "./GenericDetailTablePanel.module.css";

function emptyRow(columns) {
  return columns.map(() => "");
}

export default function GenericDetailTablePanel({ columns, onRowsChange }) {
  const [rows, setRows] = useState([emptyRow(columns)]);

  const updateCell = (rowIdx, colIdx, value) => {
    const next = rows.map((row, ri) => (ri === rowIdx ? row.map((cell, ci) => (ci === colIdx ? value : cell)) : row));
    setRows(next);
    onRowsChange(next);
  };

  const addRow = () => {
    const next = [...rows, emptyRow(columns)];
    setRows(next);
    onRowsChange(next);
  };

  const removeRow = (rowIdx) => {
    const next = rows.filter((_, ri) => ri !== rowIdx);
    setRows(next);
    onRowsChange(next);
  };

  return (
    <div className={styles.panel}>
      <div className={styles.header}>
        <span>세부내역</span>
        <button type="button" onClick={addRow} className={styles.addBtn}>+ 행 추가</button>
      </div>
      <table className={styles.table}>
        <thead>
          <tr>
            {columns.map((col, i) => (
              <th key={i}>{typeof col === "string" ? col : col.label}</th>
            ))}
            <th className={styles.removeCol}></th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row, ri) => (
            <tr key={ri}>
              {row.map((cell, ci) => (
                <td key={ci}>
                  <input
                    value={cell}
                    onChange={(e) => updateCell(ri, ci, e.target.value)}
                    className={styles.cellInput}
                  />
                </td>
              ))}
              <td className={styles.removeCol}>
                <button type="button" onClick={() => removeRow(ri)} className={styles.removeBtn}>×</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
